import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";

export const container = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "95vh",
});

export const bodyContainer = ({ breakpoints }: Theme) => ({
  width: { xs: "100%", sm: "500px" },
  height: "100%",
  background: colors.main_gradient,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: { xs: "50px 50px 0 0", sm: "50px" },
  mt: "90px",
  py: "80px",
  boxShadow: {
    sm: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
  },
});

export const subContainer = ({ breakpoints }: Theme) => ({
  mx: "30px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: { xs: "350px", sm: "440px" },
});

export const titleText = ({ breakpoints }: Theme) => ({
  color: "white",
  fontSize: "30px",
  fontWeight: 600,
});

export const divider = ({ breakpoints }: Theme) => ({
  width: "100%",
  "&::before, &::after": {
    borderColor: colors.light_gray,
  },
  color: colors.dark_gray,
  mt: 1,
  marginBottom: 7,
});

export const input = ({ breakpoints }: Theme) => ({
  mt: 1,
  borderRadius: 4,
  input: {
    background: "white",
    borderRadius: "6px",
  },
});

export const authButton = ({ breakpoints }: Theme) => ({
  mt: 1,
  mb: 2,
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  fontWeight: 600,
});

export const forgotButton = ({ breakpoints }: Theme) => ({
  color: "black",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  mb: 4,
});

export const googleButton = ({ breakpoints }: Theme) => ({
  mt: 1,
  mb: 2,
  color: "black",
  textTransform: "none",
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "white",
  },
  fontWeight: 600,
});
